export default __webpack_public_path__ + "static/media/decorator.011a6cd9.svg";